<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>下載文件</h1>
        </div>
      </header>
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-9">
                <!-- download-doc-list -->
                <div class="download-doc-list">
                  <!-- download-doc -->
                  <div
                    v-for="file in fileList"
                    :key="file.id"
                    class="download-doc"
                  >
                    <div class="download-doc-left">
                      <h4 class="text-primary">
                        {{ file.name }}
                      </h4>
                      <p>{{ file.description }}</p>
                    </div>
                    <div class="download-doc-right">
                      <a
                        :href="file.url"
                        target="_blank"
                        class="btn btn-primary"
                        >下載此文件</a
                      >
                    </div>
                  </div>
                  <!-- download-doc end -->
                </div>
                <!-- download-doc-list -->
              </div>
            </div>
          </div>
        </section>
      </section>
    </PublicLayout>
  </div>
</template>
<script>
import PublicLayout from "../../components/public/PublicLayout";
import db from "../../api/db";
export default {
  name: "DownloadDocsScreen",
  components: {
    PublicLayout,
  },
  data() {
    return {
      fileList: [],
    };
  },
  mounted() {
    const vm = this;
    db.collection("webPublicFileList")
      .get()
      .then((docs) => {
        const fileList = [];
        docs.forEach((doc) => {
          const file = doc.data();
          file.id = doc.id;
          fileList.push(file);
        });
        vm.fileList = fileList;
      })
      .catch((err) => {
        console.log("Get web public file failed", err);
      });
  },
};
</script>